import atoms from "../../atoms";
import { priceTagFormatter } from "../../../constants/utils";
import { useEffect, useRef } from "react";
import { FiEdit } from "react-icons/fi";

const { Pagination, Search, Table, CustomImages, ToggleContainer,Button } = atoms

const Index = ({ productList, setSearch, currentPage, setCurrentPage, setLimitPerPage, limit, isContactLensProduct, setIsContactLensProduct,_handleEdit }: any) => {
    const searchRef: any = useRef()
    const columns = [
        { name: 'Product ID', selector: (row: any) => row?.product?.product_id_display, },
        { name: 'Product Type', selector: (row: any) => row?.product?.product_type?.name, },
        { name: 'Cover Image', cell: (row: any) => <CustomImages src={row?.product?.images[0] && row?.product?.images[0]} height="75%" />, center: true },
        { name: 'With Case', selector: (row: any) => row?.product?.product_with_case ? "Yes" : "No", },

        { name: 'Brand', selector: (row: any) => row?.product?.brand?.brand_name || '-', },
        { name: 'Brand Color Code', selector: (row: any) => row?.product?.brand_color_code || '-', },
        { name: 'Model No', selector: (row: any) => row?.product?.modal_number || '-', },
        { name: 'Glass Size/Power', selector: (row: any) => row?.product?.glass_size || '-', },
        { name: 'SKU', selector: (row: any) => row?.product?.barcodes?.map((item:{sku_number:{sku_number:string}}, index: number) => {
            return (
                <span>
                    {`${item?.sku_number?.sku_number || ''}${index < (row?.product?.barcodes?.length - 1) ? "," : ""}`}
                </span>
            )
        }) || '-', },

        { name: 'SRP', selector: (row: any) => priceTagFormatter(row?.product?.product_srp) || '-', },
        { name: 'Action', selector: (row: any) => row?.action,minWidth:"150px"  },
    ]
    const columnsTwo = [
        { name: 'Product ID', selector: (row: any) => row?.product?.product_id_display, },
        { name: 'Product Type', selector: (row: any) => row?.product?.product_type?.name, },
        { name: 'Cover Image', cell: (row: any) => <CustomImages src={row?.product?.images[0] && row?.product?.images[0]} height="75%" />, center: true },
        { name: 'Brand', selector: (row: any) => row?.product?.brand?.brand_name || '-', },
        { name: 'Color', selector: (row: any) => row?.product?.color?.color_name || '-', },
        { name: 'SKU', selector: (row: any) => row?.product?.barcodes?.map((item:{sku_number:{sku_number:string}}, index: number) => {
            return (
                <span>
                    {`${item?.sku_number?.sku_number || ''}${index < (row?.product?.barcodes?.length - 1) ? "," : ""}`}
                </span>
            )
        }) || '-', },
        { name: 'SRP', selector: (row: any) => priceTagFormatter(row?.product?.product_srp) || '-', },
        { name: 'Action', selector: (row: any) => row?.is_branch_request ? row?.action : '-',minWidth:"140px" },
    ]

    useEffect(() => {
        if (searchRef?.current) {
            searchRef.current.value = "";
        }
    }, [isContactLensProduct]);

    const handleToggle = (value: any) => {
        setSearch('')
        setIsContactLensProduct(value)
    }

    return (
        <>
            <div className='row mt-3'>
                <div className='col-12 col-md-6'>
                    <Search className='search search-style' inputRef={searchRef} searchCallBack={(e: string) => { setSearch(e) }} />
                </div>
                <div className='col-12 col-md-6 d-flex justify-content-end'>
                    <ToggleContainer firstName="Contact Lens" secondName="Other Products" value={isContactLensProduct}
                        onStatusChange={(value: boolean) => { handleToggle(value) }} />
                </div>
                <div>
                    <Table
                        columns={isContactLensProduct ? columnsTwo : columns}
                        data={productList?.data?.map((item: any) => {
                            return ({
                                ...item,
                                action:(
                                    <Button className="table-edit-button fs-14 fw-400"
                                    onClick={() => _handleEdit(item?.id,item?.product?.id)}>
                                    <div className='d-flex align-items-center'>
                                        <FiEdit />
                                        <span className='ms-2 mb-0'>Deliver</span>
                                    </div>
                                </Button>
                                )
                            })
                        })}
                    />

                </div>
                <div>
                    <Pagination
                        totalCount={productList?.count}
                        currentPage={currentPage}
                        totalPages={productList?.totalPages}
                        onChangePage={(page: any) => setCurrentPage(page)}
                        setLimit={(e: number) => setLimitPerPage(e)}
                        limit={limit}
                    />
                </div>
            </div>
        </>
    )
}

export default Index